import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { getCostCenterDetails } from 'RestAPIs/admin';

import { showSnackbar } from 'components/shared';

export const useGetCostCenterDetails = () => {
  const { t } = useTranslation('common');

  return useQuery({
    queryKey: ['costCenterDetails'],
    queryFn: async () =>
      await getCostCenterDetails().then((response) => response.data),
    onError: () => {
      showSnackbar({
        severity: 'error',
        message: t('errorDuringFetching')
      });
    }
  });
};
